export
const name: string = "ShadowMapPoisson";

export
const preproc: string = ``;

export
const declaration: string = `
	uniform sampler2D   u_texture;
	uniform vec3        u_light_pos;
	uniform float       u_texture_size;
	uniform vec2        u_poisson[16];
`;

export
const varyings: string = `
	varying float   v_visibility;
	varying vec4    v_position;
	varying vec4    v_frag_position;
	varying vec3    v_light_position;
	varying vec3    v_normal;
`;

export
const implementation: string = `
	// Returns a random number based on a vec3 and an int.
	float random(vec3 seed, int i){
		vec4 seed4 = vec4(seed,i);
		float dot_product = dot(seed4, vec4(12.9898,78.233,45.164,94.673));
		return fract(sin(dot_product) * 43758.5453);
	}

	float getShadowMap()
	{
	    // Shadow
	    float shadow = 0.0;

	    // Shadow Acne (bias)
	    vec3 fragPosition = (v_frag_position.xyz / v_frag_position.w).xyz;
	    vec3 lightDir = normalize(u_light_pos - fragPosition);
	    float bias = 0.001 * (1.0 - dot(v_normal, lightDir));

	    float currentDepth = v_light_position.z - bias;
	    float closesstDepth = texture2D(u_texture, v_light_position.xy).r;
	    //float closesstDepth = vec4ToFloat(texture2D(u_shadow_map_texture, v_light_position.xy));

	    // Poisson disk
	    vec2 texelSize = 1.0 / vec2(u_texture_size);
	    for (int i = 0; i < 16; ++i) {
	        vec2 offset = u_poisson[i] * 4.0 * texelSize * (random(fragPosition, i) - 0.5);
	        float pcfDepth = texture2D(u_texture, v_light_position.xy + offset).r;
	        //float pcfDepth = vec4ToFloat(texture2D(u_shadow_map_texture, v_light_position.xy + vec2(x, y) * texelSize));
	        shadow += currentDepth > pcfDepth ? 1.0 : 0.0;
	    }

	    shadow /= 16.0;

	    // Test light frustum
	    if (v_light_position.x <= 1.0 && v_light_position.x >= 0.0 &&
	        v_light_position.y <= 1.0 && v_light_position.y >= 0.0 &&
	        v_light_position.z <= 1.0 && v_light_position.z >= 0.0) {

	        return 1.0 - shadow;
	    }
	    else {
	        return 1.0;
	    }
	}

	void main()
	{
	    if (v_visibility < 0.5) {
	        discard;
	    }

	#ifdef CLIPPING_PLANE
	    resolveClippingPlane();
	#endif

	    gl_FragColor = vec4(vec2(getShadowMap()), v_position.z, 1.0);

	#ifdef LOGDEPTH
	    resolveLogarithmicDepth();
	#endif
	}
`;
